<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-cart">
              {{ $t("homeMenuCartInfoCartTitle") }}
              <v-avatar
                v-if="$store.state.storeCart.cart.length > 0"
                color="error"
                size="28"
                class="ml-1"
              >
                <span class="white--text subtitle-2">
                  {{ $store.state.storeCart.cart.length }}
                </span>
              </v-avatar>
            </main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-6 pa-0 pb-10 animated fadeIn">
            <v-card
              class="#505050--text"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <transition name="fade" mode="out-in">
                <v-card-text key="4" class="ma-0 pa-0" v-show="visibleMsg">
                  <div
                    class="
                      font-weight-regular
                      px-4
                      py-2
                      ma-0
                      white--text
                      warning
                    "
                  >
                    <div class="animated bounceInRight">
                      <v-icon medium left color="white">mdi-alert</v-icon>
                      {{ $t("userCartStorageDeletionNotification") }}
                    </div>
                  </div>
                </v-card-text>
              </transition>
              <v-card-text
                v-if="$store.state.storeCart.cart.length > 0"
                class="ma-0 pa-2 py-0 py-2"
              >
                <!-- IZRAČUN MODULA ZA RAZVIJANJE SLIK -->
                <div
                  style="background-color: #fcfcfc; border: 1px solid gainsboro"
                  class="ma-0"
                  v-if="
                    $store.state.storeCart.cart.filter(
                      (x) => x.module == G_MODULE_PHOTO_ORDER
                    ).length > 0
                  "
                >
                  <div
                    class="
                      subtitle-1
                      font-weight-regular
                      px-4
                      py-2
                      white--text
                      primary
                    "
                  >
                    {{ $t("userCartModPhotoOrdersTitle") }} ({{
                      $store.state.storeCart.modPhotoOrderSummary.totalCopies
                    }})
                  </div>
                  <v-card
                    v-if="
                      (this.$store.state.storeClient.client.modules
                        .modulePhotoOrder.minOrder > 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumPromoCodeDiscountPrice > 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumPromoCodeDiscountPrice <
                          this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.minOrder) ||
                      (this.$store.state.storeClient.client.modules
                        .modulePhotoOrder.minOrder > 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumPromoCodeDiscountPrice == 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumExtraCharge <
                          this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.minOrder)
                    "
                    class="ma-0 mb-3 pa-0"
                    color="error"
                    dark
                    flat
                  >
                    <v-card-text class="ma-0 px-2 py-1">
                      <v-icon class="white--text" small>mdi-alert</v-icon>
                      {{ $t("userCartModPhotoOrdersMinOrderError") }}
                      {{
                        price(
                          this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.minOrder
                        )
                      }}
                      {{ $t("userCartModPhotoOrdersMinOrderError2") }}
                    </v-card-text>
                  </v-card>
                  <v-list-item
                    v-for="item in $store.state.storeCart.cart.filter(
                      (x) => x.module == G_MODULE_PHOTO_ORDER
                    )"
                    :key="item.id"
                    class="ma-0 pa-0 px-4 pt-2"
                    three-line
                  >
                    <v-list-item-content class="ma-0 pa-0">
                      <v-list-item-title class="subtitle-1 d-flex">
                        <v-btn
                          color="error"
                          style="width: 20px"
                          class="mr-2"
                          fab
                          text
                          small
                          @click="deleteItem(item)"
                        >
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="$store.state.storeAuth.userProfile.isAdmin"
                          class="mr-1"
                          fab
                          text
                          small
                          color="secondary"
                          @click.stop
                          :href="item.url"
                        >
                          <v-icon>mdi-folder-download</v-icon>
                        </v-btn>
                        <v-icon v-else class="mr-2">mdi-folder-download</v-icon>
                        <div class="pt-2">
                          {{ $t("userCartModPhotoOrderPackageTitle") }} ({{
                            item.totalCopies
                          }})
                        </div>
                      </v-list-item-title>
                      <v-list-item-subtitle class="overline">
                        <div
                          v-for="item2 in item.imageDataStr"
                          :key="item2.str"
                        >
                          {{ item2.str }}
                        </div>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle
                        class="mb-0 caption font-italic font-weight-light"
                      >
                        {{ $t("msgAddedTitle") }}
                        {{ timePassedSinceAdd(item.timestamp.seconds) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content style="color: gray" class="body-2">
                      <div class="pb-2">
                        {{ $t("userNewOrderSummary2Title") }}:
                        {{
                          price(
                            $store.state.storeCart.modPhotoOrderSummary
                              .totalSumLabPrice
                          )
                        }}
                      </div>
                      <!-- izpis morebitnega količinskega popusta -->
                      <div
                        v-if="
                          $store.state.storeCart.modPhotoOrderSummary
                            .totalSumQuantityDiscountPrice > 0
                        "
                      >
                        <div class="pb-2">
                          {{ $t("userNewOrderSummary3Title") }}:
                          {{
                            price(
                              $store.state.storeCart.modPhotoOrderSummary
                                .totalSumQuantityDiscountPrice
                            )
                          }}
                          (-{{
                            percent(
                              $store.state.storeCart.modPhotoOrderSummary
                                .totalSumQuantityDiscount
                            )
                          }})
                        </div>
                        <div class="pb-2">
                          {{ $t("userNewOrderSummary4Title") }}:
                          {{
                            price(
                              $store.state.storeCart.modPhotoOrderSummary
                                .totalSumQuantityPrice
                            )
                          }}
                        </div>
                      </div>
                      <!-- Če je na voljo količinsi popust, ga ponudimo -->
                      <v-card
                        v-if="
                          this.$store.state.storeCart.modPhotoOrderSummary
                            .totalSumQuantityNextCopies <
                          gLastQuantityDiscountNumber
                        "
                        class="ma-0 mb-3 pa-0"
                        color="accent"
                        dark
                        flat
                      >
                        <v-card-text class="ma-0 px-2 py-1">
                          <div>
                            <v-icon class="white--text" small>mdi-sale</v-icon>
                            {{ $t("userCartModPhotoOrderAddMore1Title") }}
                            <strong>
                              {{
                                this.$store.state.storeCart.modPhotoOrderSummary
                                  .totalSumQuantityNextCopies -
                                this.$store.state.storeCart.modPhotoOrderSummary
                                  .totalCopies
                              }}
                            </strong>
                            {{ $t("userCartModPhotoOrderAddMore2Title") }}
                            <strong>
                              {{
                                percent(
                                  this.$store.state.storeCart
                                    .modPhotoOrderSummary
                                    .totalSumQuantityNextDiscount -
                                    $store.state.storeCart.modPhotoOrderSummary
                                      .totalSumQuantityDiscount
                                )
                              }} </strong
                            >!
                          </div>
                        </v-card-text>
                      </v-card>
                      <!-- morebitni extraCharge -->
                      <div
                        v-if="
                          this.$store.state.storeCart.modPhotoOrderSummary
                            .totalSumExtraCharge >
                          this.$store.state.storeCart.modPhotoOrderSummary
                            .totalSumQuantityPrice
                        "
                      >
                        <div class="pb-2">
                          {{
                            this.$store.state.storeClient.client.modules
                              .modulePhotoOrder.extraChargeMessage
                          }}:
                          {{
                            price(
                              this.$store.state.storeClient.client.modules
                                .modulePhotoOrder.extraCharge
                            )
                          }}
                        </div>
                        <div class="pb-2">
                          {{ $t("userNewOrderSummaryExtraChargeTitle") }}:
                          {{
                            price(
                              this.$store.state.storeCart.modPhotoOrderSummary
                                .totalSumExtraCharge
                            )
                          }}
                        </div>
                      </div>
                      <!-- morebitni extraChargeFreeOver -->
                      <v-card
                        v-if="
                          this.$store.state.storeCart.modPhotoOrderSummary
                            .totalSumExtraCharge >
                            this.$store.state.storeCart.modPhotoOrderSummary
                              .totalSumQuantityPrice &&
                          this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.extraChargeFreeOver > 0 &&
                          this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.extraChargeFreeOver >
                            this.$store.state.storeCart.modPhotoOrderSummary
                              .totalSumExtraCharge
                        "
                        class="ma-0 mt-2 mb-3 pa-0"
                        color="accent"
                        dark
                        flat
                      >
                        <v-card-text class="ma-0 px-2 py-1">
                          <div>
                            <v-icon class="white--text" small>mdi-sale</v-icon>
                            {{ $t("userCartModPhotoOrderAddMore1Title") }}
                            <strong>
                              {{
                                price(
                                  parseFloat(
                                    this.$store.state.storeClient.client.modules
                                      .modulePhotoOrder.extraChargeFreeOver
                                  ) -
                                    this.$store.state.storeCart
                                      .modPhotoOrderSummary.totalSumExtraCharge
                                )
                              }}
                            </strong>
                            {{ $t("userCartModPhotoOrderAddMore2Title") }}
                            <strong>
                              {{
                                price(
                                  this.$store.state.storeClient.client.modules
                                    .modulePhotoOrder.extraCharge
                                )
                              }} </strong
                            >!
                          </div>
                        </v-card-text>
                      </v-card>
                      <!-- Če je na voljo količinsi popust ali extraChargeFreeOver, dodamo gumb za naročanje slik -->
                      <div
                        class="d-flex"
                        v-if="
                          this.$store.state.storeCart.modPhotoOrderSummary
                            .totalSumQuantityNextCopies <
                            gLastQuantityDiscountNumber ||
                          (this.$store.state.storeCart.modPhotoOrderSummary
                            .totalSumExtraCharge >
                            this.$store.state.storeCart.modPhotoOrderSummary
                              .totalSumQuantityPrice &&
                            this.$store.state.storeClient.client.modules
                              .modulePhotoOrder.extraChargeFreeOver > 0 &&
                            this.$store.state.storeClient.client.modules
                              .modulePhotoOrder.extraChargeFreeOver >
                              this.$store.state.storeCart.modPhotoOrderSummary
                                .totalSumExtraCharge) ||
                          (this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.minOrder > 0 &&
                            this.$store.state.storeCart.modPhotoOrderSummary
                              .totalSumExtraCharge <
                              this.$store.state.storeClient.client.modules
                                .modulePhotoOrder.minOrder)
                        "
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          outlined
                          class="mt-0"
                          to="/userNewOrderBasic"
                        >
                          {{
                            $t(
                              "dashboardCardModulePhotoOrderUserOrderButtonTitle"
                            )
                          }}
                        </v-btn>
                        <v-spacer></v-spacer>
                      </div>
                      <!-- aktivna promo koda -->
                      <div
                        v-if="
                          this.$store.state.storeCart.modPhotoOrderSummary
                            .totalSumPromoCodeDiscount > 0
                        "
                      >
                        <div class="pb-2">
                          {{ $t("userNewOrderSummary5Title") }}:
                          {{
                            price(
                              this.$store.state.storeCart.modPhotoOrderSummary
                                .totalSumPromoCodeDiscount
                            )
                          }}
                          (-<span
                            v-if="
                              this.$store.state.storeCart
                                .activePromoCodeDiscountType == 'Pct'
                            "
                            >{{
                              percent(
                                this.$store.state.storeCart
                                  .activePromoCodeDiscount
                              )
                            }}</span
                          ><span
                            v-else-if="
                              this.$store.state.storeCart
                                .activePromoCodeDiscountType == 'Amt'
                            "
                            >{{
                              price(
                                this.$store.state.storeCart
                                  .activePromoCodeDiscount
                              )
                            }}</span
                          >)
                        </div>
                        <div>
                          {{ $t("userNewOrderSummary5cTitle") }}:
                          {{
                            price(
                              this.$store.state.storeCart.modPhotoOrderSummary
                                .totalSumPromoCodeDiscountPrice
                            )
                          }}
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </div>

                <!-- IZRAČUN MODULA ZA FOTO IZDELKE -->
                <div
                  style="background-color: #fcfcfc; border: 1px solid gainsboro"
                  class="ma-0"
                  v-if="
                    $store.state.storeCart.cart.filter(
                      (x) => x.module == G_MODULE_PHOTO_GIFT
                    ).length > 0
                  "
                >
                  <div
                    class="
                      subtitle-1
                      font-weight-regular
                      px-4
                      py-2
                      white--text
                      primary
                    "
                  >
                    {{ $t("userCartModPhotoGiftTitle") }} ({{
                      $store.state.storeCart.modPhotoGiftSummary.totalCopies
                    }})
                  </div>
                  <v-list-item
                    v-for="item in $store.state.storeCart.cart.filter(
                      (x) => x.module == G_MODULE_PHOTO_GIFT
                    )"
                    :key="item.id"
                    class="ma-0 pa-0 px-4 pt-2"
                    three-line
                  >
                    <v-list-item-content class="ma-0 pa-0">
                      <v-list-item-title class="subtitle-1 d-flex">
                        <v-btn
                          color="error"
                          fab
                          text
                          small
                          style="width: 20px"
                          class="mr-2"
                          @click="deleteItem(item)"
                        >
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                        <!-- admin ima na voljo gumb za download, da ni treba zaključiti naročila -->
                        <v-btn
                          v-if="$store.state.storeAuth.userProfile.isAdmin"
                          class="mr-1"
                          fab
                          text
                          small
                          color="secondary"
                          @click.stop
                          :href="item.url"
                        >
                          <span v-if="item.superType !== undefined">
                            <v-icon v-if="item.superType == 0"
                              >mdi-package-variant</v-icon
                            >
                            <v-icon v-else-if="item.superType == 1"
                              >mdi-glass-mug</v-icon
                            >
                            <v-icon v-else-if="item.superType == 2"
                              >mdi-collage</v-icon
                            >
                            <v-icon v-else-if="item.superType == 3"
                              >mdi-picture-in-picture-bottom-right</v-icon
                            >
                            <v-icon v-else-if="item.superType == 4"
                              >mdi-wallet-giftcard</v-icon
                            >
                            <v-icon v-else-if="item.superType == 5"
                              >mdi-resize</v-icon
                            >
                            <v-icon v-else-if="item.superType == 6"
                              >mdi-palette</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon>mdi-glass-mug</v-icon>
                          </span>
                        </v-btn>
                        <!-- ostali uporabniki pa imajo samo ikono -->
                        <span v-else>
                          <span v-if="item.superType !== undefined">
                            <v-icon class="mr-2" v-if="item.superType == 0"
                              >mdi-package-variant</v-icon
                            >
                            <v-icon class="mr-2" v-else-if="item.superType == 1"
                              >mdi-glass-mug</v-icon
                            >
                            <v-icon class="mr-2" v-else-if="item.superType == 2"
                              >mdi-collage</v-icon
                            >
                            <v-icon class="mr-2" v-else-if="item.superType == 3"
                              >mdi-picture-in-picture-bottom-right</v-icon
                            >
                            <v-icon class="mr-2" v-else-if="item.superType == 4"
                              >mdi-wallet-giftcard</v-icon
                            >
                            <v-icon class="mr-2" v-else-if="item.superType == 5"
                              >mdi-resize</v-icon
                            >
                            <v-icon class="mr-2" v-else-if="item.superType == 6"
                              >mdi-palette</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon class="mr-2">mdi-glass-mug</v-icon>
                          </span>
                        </span>
                        <div class="pt-2">
                          {{ item.itemName }} ({{ item.itemCopies }})
                        </div>
                      </v-list-item-title>
                      <v-list-item-subtitle class="overline">{{
                        item.imageDataStr
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle
                        class="mb-0 caption font-italic font-weight-light"
                      >
                        {{ $t("msgAddedTitle") }}
                        {{ timePassedSinceAdd(item.timestamp.seconds) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content style="color: gray" class="body-2">
                      <div class="pb-2 pt-2">
                        {{ $t("userNewOrderSummary2Title") }}:
                        {{
                          price(
                            $store.state.storeCart.modPhotoGiftSummary
                              .totalSumLabPrice
                          )
                        }}
                      </div>

                      <!-- morebitni extraCharge -->
                      <div
                        v-if="
                          this.$store.state.storeCart.modPhotoGiftSummary
                            .totalSumExtraCharge >
                          this.$store.state.storeCart.modPhotoGiftSummary
                            .totalSumLabPrice
                        "
                      >
                        <div class="pb-2">
                          {{
                            this.$store.state.storeClient.client.modules
                              .modulePhotoGift.extraChargeMessage
                          }}:
                          {{
                            price(
                              this.$store.state.storeClient.client.modules
                                .modulePhotoGift.extraCharge
                            )
                          }}
                        </div>
                        <div class="pb-2">
                          {{ $t("userNewOrderSummaryExtraChargeTitle") }}:
                          {{
                            price(
                              this.$store.state.storeCart.modPhotoGiftSummary
                                .totalSumExtraCharge
                            )
                          }}
                        </div>
                      </div>
                      <!-- morebitni extraChargeFreeOver -->
                      <v-card
                        v-if="
                          this.$store.state.storeCart.modPhotoGiftSummary
                            .totalSumExtraCharge >
                            this.$store.state.storeCart.modPhotoGiftSummary
                              .totalSumLabPrice &&
                          this.$store.state.storeClient.client.modules
                            .modulePhotoGift.extraChargeFreeOver > 0 &&
                          this.$store.state.storeClient.client.modules
                            .modulePhotoGift.extraChargeFreeOver >
                            this.$store.state.storeCart.modPhotoGiftSummary
                              .totalSumExtraCharge
                        "
                        class="ma-0 mt-2 mb-3 pa-0"
                        color="accent"
                        dark
                        flat
                      >
                        <v-card-text class="ma-0 px-2 py-1">
                          <div>
                            <v-icon class="white--text" small>mdi-sale</v-icon>
                            {{ $t("userCartModPhotoOrderAddMore1Title") }}
                            <strong>
                              {{
                                price(
                                  parseFloat(
                                    this.$store.state.storeClient.client.modules
                                      .modulePhotoGift.extraChargeFreeOver
                                  ) -
                                    this.$store.state.storeCart
                                      .modPhotoGiftSummary.totalSumExtraCharge
                                )
                              }}
                            </strong>
                            {{ $t("userCartModPhotoGiftAddMore2Title") }}
                            <strong>
                              {{
                                price(
                                  this.$store.state.storeClient.client.modules
                                    .modulePhotoGift.extraCharge
                                )
                              }} </strong
                            >!
                          </div>
                        </v-card-text>
                      </v-card>
                      <!-- Če je na voljo extraChargeFreeOver, dodamo gumb za naročanje izdelkov -->
                      <div
                        class="d-flex"
                        v-if="
                          this.$store.state.storeCart.modPhotoGiftSummary
                            .totalSumExtraCharge >
                            this.$store.state.storeCart.modPhotoGiftSummary
                              .totalSumLabPrice &&
                          this.$store.state.storeClient.client.modules
                            .modulePhotoGift.extraChargeFreeOver > 0 &&
                          this.$store.state.storeClient.client.modules
                            .modulePhotoGift.extraChargeFreeOver >
                            this.$store.state.storeCart.modPhotoGiftSummary
                              .totalSumExtraCharge
                        "
                      >
                        <v-spacer></v-spacer>
                      </div>

                      <!-- aktivna promo koda -->
                      <div
                        v-if="
                          this.$store.state.storeCart.modPhotoGiftSummary
                            .totalSumPromoCodeDiscount > 0
                        "
                      >
                        <div class="pb-2">
                          {{ $t("userNewOrderSummary5Title") }}:
                          {{
                            price(
                              this.$store.state.storeCart.modPhotoGiftSummary
                                .totalSumPromoCodeDiscount
                            )
                          }}
                          <span
                            v-if="
                              $store.state.storeCart
                                .activePromoCodeSuperCategory != ''
                            "
                            >/
                            {{
                              $store.state.storeCart
                                .activePromoCodeSuperCategoryName
                            }}</span
                          >
                          <span
                            v-if="
                              $store.state.storeCart.activePromoCodeCategory !=
                              ''
                            "
                          >
                            /
                            {{
                              $store.state.storeCart.activePromoCodeCategoryName
                            }}</span
                          >
                          <span
                            v-if="
                              $store.state.storeCart.activePromoCodeItem != ''
                            "
                            >/
                            {{
                              $store.state.storeCart.activePromoCodeItemName
                            }}</span
                          >
                          <span
                            v-if="
                              $store.state.storeCart.activePromoCodeSubItem !=
                              ''
                            "
                          >
                            /
                            {{
                              $store.state.storeCart.activePromoCodeSubItemName
                            }}</span
                          >
                          (-<span
                            v-if="
                              $store.state.storeCart
                                .activePromoCodeDiscountType == 'Pct'
                            "
                            >{{
                              percent(
                                $store.state.storeCart.activePromoCodeDiscount
                              )
                            }}</span
                          ><span
                            v-else-if="
                              $store.state.storeCart
                                .activePromoCodeDiscountType == 'Amt'
                            "
                            >{{
                              price(
                                $store.state.storeCart.activePromoCodeDiscount
                              )
                            }}</span
                          >)
                        </div>
                        <div>
                          {{ $t("userNewOrderSummary5cTitle") }}:
                          {{
                            price(
                              this.$store.state.storeCart.modPhotoGiftSummary
                                .totalSumPromoCodeDiscountPrice
                            )
                          }}
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </div>

                <!-- PROMO CODE INTEGRATION -->
                <div
                  style="background-color: #fcfcfc; border: 1px solid gainsboro"
                  class="ma-0 mt-2"
                >
                  <!--  Možnost vpisa promo kode pokažemo le če je kakšna aktivna -->
                  <div class="ma-3">
                    <v-text-field
                      class="ma-0 pa-0"
                      style="height: 40px"
                      :label="$t('userNewOrderSummary5PromptTitle')"
                      v-model="$store.state.storeCart.activePromoCode"
                      outlined
                      dense
                      @input="checkPromoCodeActivation()"
                      v-if="!$store.state.storeCart.activePromoCodeActivated"
                    ></v-text-field>
                    <div v-else class="mx-1 my-1">
                      <div class="body-2">
                        {{ $t("userNewOrderSummary5aTitle") }}:
                        <strong>
                          {{
                            $store.state.storeCart.activePromoCode.toUpperCase()
                          }}
                        </strong>
                        /
                        {{
                          getModuleName(
                            this.$store.state.storeCart.activePromoCodeModule
                          )
                        }}
                        <span
                          v-if="
                            $store.state.storeCart
                              .activePromoCodeSuperCategory != ''
                          "
                          >/
                          {{
                            $store.state.storeCart
                              .activePromoCodeSuperCategoryName
                          }}</span
                        >
                        <span
                          v-if="
                            $store.state.storeCart
                              .activePromoCodeSuperCategory != ''
                          "
                        >
                          /
                          {{
                            $store.state.storeCart.activePromoCodeCategoryName
                          }}</span
                        >
                        <span
                          v-if="
                            $store.state.storeCart.activePromoCodeItem != ''
                          "
                          >/
                          {{
                            $store.state.storeCart.activePromoCodeItemName
                          }}</span
                        >
                        <span
                          v-if="
                            $store.state.storeCart.activePromoCodeSubItem != ''
                          "
                        >
                          /
                          {{
                            $store.state.storeCart.activePromoCodeSubItemName
                          }}</span
                        >
                        (-<span
                          v-if="
                            this.$store.state.storeCart
                              .activePromoCodeDiscountType == 'Pct'
                          "
                          >{{
                            percent(
                              this.$store.state.storeCart
                                .activePromoCodeDiscount
                            )
                          }}</span
                        ><span
                          v-else-if="
                            this.$store.state.storeCart
                              .activePromoCodeDiscountType == 'Amt'
                          "
                          >{{
                            price(
                              this.$store.state.storeCart
                                .activePromoCodeDiscount
                            )
                          }}</span
                        >)
                      </div>
                      <div>
                        {{ $t("userNewOrderSummary5dTitle") }}:
                        {{
                          price(
                            this.$store.state.storeCart
                              .totalSumPromoCodeDiscount
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <!-- KONČNI ZNESEK -->
                  <div
                    class="
                      subtitle-1
                      font-weight-regular
                      px-4
                      py-2
                      white--text
                      warning
                    "
                  >
                    {{ $t("userNewOrderSummary6Title") }}:
                    {{ price(this.$store.state.storeCart.totalSumCart) }}
                  </div>
                </div>

                <div class="ma-2 caption">
                  {{ $t("userNewOrderSummaryAddInfoTitle") }}
                </div>

                <!-- GUMB BLAGAJNA -->
                <div class="d-flex">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="secondary"
                    to="/userCashier"
                    class="mt-2 mb-3"
                    :disabled="
                      !this.enableCashregister ||
                      (this.$store.state.storeCart.modPhotoOrderSummary
                        .totalCopies > 0 &&
                        this.$store.state.storeClient.client.modules
                          .modulePhotoOrder.minOrder > 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumPromoCodeDiscountPrice > 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumPromoCodeDiscountPrice <
                          this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.minOrder) ||
                      (this.$store.state.storeCart.modPhotoOrderSummary
                        .totalCopies > 0 &&
                        this.$store.state.storeClient.client.modules
                          .modulePhotoOrder.minOrder > 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumPromoCodeDiscountPrice == 0 &&
                        this.$store.state.storeCart.modPhotoOrderSummary
                          .totalSumExtraCharge <
                          this.$store.state.storeClient.client.modules
                            .modulePhotoOrder.minOrder)
                    "
                  >
                    <v-icon class="mr-2">mdi-cash-register</v-icon>
                    {{ $t("homeMenuCartInfoCashierTitle") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </div>
              </v-card-text>

              <!-- PRAZNA KOŠARICA -->
              <v-card-text v-else class="ma-0 py-5">
                <v-icon small>mdi-emoticon-sad-outline</v-icon>
                <span class="ml-2 subtitle-2">
                  {{ $t("homeMenuCartInfoEmpty") }}
                </span>
              </v-card-text>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

import {
  G_MODULE_PHOTO_ORDER,
  G_MODULE_PHOTO_GIFT,
  G_MODULE_ALL,
} from "@/constants";
import { G_LAST_QUANTITY_DISCOUNT_NUMBER } from "@/constants";

export default {
  name: "userCart",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
  data() {
    return {
      gLastQuantityDiscountNumber: G_LAST_QUANTITY_DISCOUNT_NUMBER,
      netBackImage: require("@/assets/netBack.png"),
      visibleMsg: true,
      enableCashregister: false,
    };
  },
  methods: {
    checkPromoCodeActivation() {
      let activationObj =
        this.$store.state.storePromoCode.activePromoCodes.filter(
          (item) =>
            item.promoCode.toUpperCase() ==
            this.$store.state.storeCart.activePromoCode.toUpperCase()
        );
      if (activationObj.length > 0) {
        this.$store.state.storeCart.activePromoCodeDiscount =
          activationObj[0].discount;
        this.$store.state.storeCart.activePromoCodeId = activationObj[0].id;
        this.$store.state.storeCart.activePromoCodePermanent =
          activationObj[0].permanent;
        this.$store.state.storeCart.activePromoCodeModule =
          activationObj[0].module;
        this.$store.state.storeCart.activePromoCodeItem = activationObj[0].item;
        this.$store.state.storeCart.activePromoCodeItemName =
          activationObj[0].itemName !== undefined
            ? activationObj[0].itemName
            : "";
        this.$store.state.storeCart.activePromoCodeSubItem =
          activationObj[0].subItem;
        this.$store.state.storeCart.activePromoCodeSubItemName =
          activationObj[0].subItemName !== undefined
            ? activationObj[0].subItemName
            : "";
        this.$store.state.storeCart.activePromoCodeSuperCategory =
          activationObj[0].superCategory;
        this.$store.state.storeCart.activePromoCodeSuperCategoryName =
          activationObj[0].superCategoryName !== undefined
            ? activationObj[0].superCategoryName
            : "";
        this.$store.state.storeCart.activePromoCodeCategory =
          activationObj[0].category;
        this.$store.state.storeCart.activePromoCodeCategoryName =
          activationObj[0].categoryName !== undefined
            ? activationObj[0].categoryName
            : "";
        this.$store.state.storeCart.activePromoCodeDiscountType =
          activationObj[0].discountType;

        console.log("storeCart", this.$store.state.storeCart);

        // izračun, kateri modul ali vsi skupaj ima popust
        this.$store.state.storeCart.totalSumPromoCodeDiscount = 0;
        this.$store.state.storeCart.totalSumPromoCodeDiscountPrice = 0;

        // POPUST ZA MODULE_PHOTO_ORDER
        if (
          this.$store.state.storeCart.activePromoCodeModule ==
            G_MODULE_PHOTO_ORDER ||
          this.$store.state.storeCart.activePromoCodeModule == G_MODULE_ALL
        ) {
          let tempExtraCharge =
            this.$store.state.storeCart.modPhotoOrderSummary
              .totalSumExtraCharge -
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumLabPrice;

          if (
            this.$store.state.storeCart.activePromoCodeDiscountType == "Pct"
          ) {
            // izračun, če je popust procentualni
            // izračun popusta za modPhotoOrder (znesek s popustom)
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice =
              (parseInt(1) -
                parseFloat(
                  this.$store.state.storeCart.activePromoCodeDiscount / 100
                )) *
              (this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumPhotoOrder -
                tempExtraCharge);

            // izračun popusta za modPhotoOrder (količina popusta)
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount =
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumPhotoOrder -
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumPromoCodeDiscountPrice -
              tempExtraCharge;

            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice +=
              tempExtraCharge;
          } else if (
            this.$store.state.storeCart.activePromoCodeDiscountType == "Amt"
          ) {
            // izračun, če je popust zneskovni
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice =
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumPhotoOrder -
              this.$store.state.storeCart.activePromoCodeDiscount -
              tempExtraCharge;

            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount =
              this.$store.state.storeCart.activePromoCodeDiscount;

            if (
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumPromoCodeDiscountPrice <= 0
            ) {
              this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice = 0;
              this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount =
                this.$store.state.storeCart.modPhotoOrderSummary
                  .totalSumPhotoOrder - tempExtraCharge;
            }
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice +=
              tempExtraCharge;
          }

          this.$store.state.storeCart.modPhotoOrderSummary.totalSumPhotoOrder =
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscountPrice;
        }

        // POPUST ZA MODULE_PHOTO_GIFT
        if (
          this.$store.state.storeCart.activePromoCodeModule ==
            G_MODULE_PHOTO_GIFT ||
          this.$store.state.storeCart.activePromoCodeModule == G_MODULE_ALL
        ) {
          let tempExtraCharge =
            this.$store.state.storeCart.modPhotoGiftSummary
              .totalSumExtraCharge -
            this.$store.state.storeCart.modPhotoGiftSummary.totalSumLabPrice;

          if (
            this.$store.state.storeCart.activePromoCodeDiscountType == "Pct"
          ) {
            // PROCENTUALNI POPUST
            if (
              this.$store.state.storeCart.activePromoCodeSuperCategory != "" &&
              this.$store.state.storeCart.activePromoCodeItem == ""
            ) {
              // če je dodatni popust na super kategorijo ali navadno kategorijo
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice = 0;

              Array.from(
                this.$store.state.storeCart.cart.filter(
                  (item) => item.module == this.G_MODULE_PHOTO_GIFT
                )
              ).forEach((item) => {
                /*console.log(
                  this.$store.state.storeCart.activePromoCodeSuperCategory,
                  "=",
                  item.itemSuperCategoryId
                );
                console.log(
                  this.$store.state.storeCart.activePromoCodeCategory,
                  "=",
                  item.itemCategoryId
                );*/
                if (
                  this.$store.state.storeCart.activePromoCodeSuperCategory ==
                    item.itemSuperCategoryId &&
                  (this.$store.state.storeCart.activePromoCodeCategory == "" ||
                    this.$store.state.storeCart.activePromoCodeCategory ==
                      item.itemCategoryId)
                ) {
                  // popust na super kategorijo ali kategorijo
                  this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                    (parseInt(1) -
                      parseFloat(
                        this.$store.state.storeCart.activePromoCodeDiscount /
                          100
                      )) *
                    item.itemPrice *
                    item.itemCopies;
                } else {
                  // izdelek se ne ujema, ni popusta
                  this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                    item.itemPrice * item.itemCopies;
                }
              });

              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                tempExtraCharge;

              // izračun popusta za modPhotoGift (količina popusta)
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount =
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPhotoGift -
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPromoCodeDiscountPrice;
            } else if (this.$store.state.storeCart.activePromoCodeItem != "") {
              // če je dodatni popust samo na en izdelek
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice = 0;

              Array.from(
                this.$store.state.storeCart.cart.filter(
                  (item) => item.module == this.G_MODULE_PHOTO_GIFT
                )
              ).forEach((item) => {
                if (
                  this.$store.state.storeCart.activePromoCodeItem == item.itemId
                ) {
                  if (
                    this.$store.state.storeCart.activePromoCodeSubItem != ""
                  ) {
                    if (
                      this.$store.state.storeCart.activePromoCodeSubItem ==
                      item.itemTypeId
                    ) {
                      this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                        (parseInt(1) -
                          parseFloat(
                            this.$store.state.storeCart
                              .activePromoCodeDiscount / 100
                          )) *
                        item.itemPrice *
                        item.itemCopies;
                    } else {
                      this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                        item.itemPrice * item.itemCopies;
                    }
                  } else {
                    // če je popust na vse različice enega izdelka
                    this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                      (parseInt(1) -
                        parseFloat(
                          this.$store.state.storeCart.activePromoCodeDiscount /
                            100
                        )) *
                      item.itemPrice *
                      item.itemCopies;
                  }
                } else {
                  this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                    item.itemPrice * item.itemCopies;
                }
              });

              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                tempExtraCharge;

              // izračun popusta za modPhotoGift (količina popusta)
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount =
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPhotoGift -
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPromoCodeDiscountPrice;
            } else {
              // če je popust generalni na vse foto izdelke
              // izračun popusta za modPhotoGift (znesek s popustom)
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice =
                (parseInt(1) -
                  parseFloat(
                    this.$store.state.storeCart.activePromoCodeDiscount / 100
                  )) *
                (this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPhotoGift -
                  tempExtraCharge);
              // izračun popusta za modPhotoGift (količina popusta)
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount =
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPhotoGift -
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPromoCodeDiscountPrice -
                tempExtraCharge;

              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                tempExtraCharge;
            }
          } else if (
            this.$store.state.storeCart.activePromoCodeDiscountType == "Amt"
          ) {
            // ZNESKOVNI POPUST
            if (
              this.$store.state.storeCart.activePromoCodeSuperCategory != "" &&
              this.$store.state.storeCart.activePromoCodeItem == ""
            ) {
              // če je dodatni popust na super kategorijo ali navadno kategorijo
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice = 0;

              let tempDiscountedItem = 0;
              Array.from(
                this.$store.state.storeCart.cart.filter(
                  (item) => item.module == this.G_MODULE_PHOTO_GIFT
                )
              ).forEach((item) => {
                if (
                  this.$store.state.storeCart.activePromoCodeSuperCategory ==
                    item.itemSuperCategoryId &&
                  (this.$store.state.storeCart.activePromoCodeCategory == "" ||
                    this.$store.state.storeCart.activePromoCodeCategory ==
                      item.itemCategoryId)
                ) {
                  // popust na super kategorijo ali kategorijo
                  tempDiscountedItem += item.itemPrice * item.itemCopies;
                } else {
                  // izdelek se ne ujema, ni popusta
                  this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                    item.itemPrice * item.itemCopies;
                }
              });

              tempDiscountedItem -=
                this.$store.state.storeCart.activePromoCodeDiscount;
              if (tempDiscountedItem < 0) tempDiscountedItem = 0;
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                tempExtraCharge + tempDiscountedItem;

              // izračun popusta za modPhotoGift (količina popusta)
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount =
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPhotoGift -
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPromoCodeDiscountPrice;
            } else if (this.$store.state.storeCart.activePromoCodeItem != "") {
              // če je dodatni popust samo na en izdelek
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice = 0;

              let tempDiscountedItem = 0;
              Array.from(
                this.$store.state.storeCart.cart.filter(
                  (item) => item.module == this.G_MODULE_PHOTO_GIFT
                )
              ).forEach((item) => {
                if (
                  this.$store.state.storeCart.activePromoCodeItem == item.itemId
                ) {
                  if (
                    this.$store.state.storeCart.activePromoCodeSubItem != ""
                  ) {
                    if (
                      this.$store.state.storeCart.activePromoCodeSubItem ==
                      item.itemTypeId
                    ) {
                      tempDiscountedItem += item.itemPrice * item.itemCopies;
                    } else {
                      this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                        item.itemPrice * item.itemCopies;
                    }
                  } else {
                    tempDiscountedItem += item.itemPrice * item.itemCopies;
                  }
                } else {
                  this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                    item.itemPrice * item.itemCopies;
                }
              });

              tempDiscountedItem -=
                this.$store.state.storeCart.activePromoCodeDiscount;
              if (tempDiscountedItem < 0) tempDiscountedItem = 0;
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                tempExtraCharge + tempDiscountedItem;

              // izračun popusta za modPhotoGift (količina popusta)
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount =
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPhotoGift -
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPromoCodeDiscountPrice;
            } else {
              // če je popust generalni na vse foto izdelke
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice =
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPhotoGift -
                this.$store.state.storeCart.activePromoCodeDiscount -
                tempExtraCharge;

              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount =
                this.$store.state.storeCart.activePromoCodeDiscount;

              if (
                this.$store.state.storeCart.modPhotoGiftSummary
                  .totalSumPromoCodeDiscountPrice <= 0
              ) {
                this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice = 0;
                this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount =
                  this.$store.state.storeCart.modPhotoGiftSummary
                    .totalSumPhotoGift - tempExtraCharge;
              }
              this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice +=
                tempExtraCharge;
            }
          }

          this.$store.state.storeCart.modPhotoGiftSummary.totalSumPhotoGift =
            this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscountPrice;
        }

        // POPUST ZA MODULE_ALL
        if (this.$store.state.storeCart.activePromoCodeModule == G_MODULE_ALL) {
          this.$store.state.storeCart.totalSumPromoCodeDiscount =
            this.$store.state.storeCart.modPhotoOrderSummary
              .totalSumPromoCodeDiscount +
            this.$store.state.storeCart.modPhotoGiftSummary
              .totalSumPromoCodeDiscount;
        } else if (
          this.$store.state.storeCart.activePromoCodeModule ==
          G_MODULE_PHOTO_ORDER
        ) {
          this.$store.state.storeCart.totalSumPromoCodeDiscount =
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount;
        } else if (
          this.$store.state.storeCart.activePromoCodeModule ==
          G_MODULE_PHOTO_GIFT
        ) {
          this.$store.state.storeCart.totalSumPromoCodeDiscount =
            this.$store.state.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount;
        }

        // izračun končnega zneska s promo popustom
        this.$store.state.storeCart.totalSumPromoCodeDiscountPrice =
          this.$store.state.storeCart.modPhotoOrderSummary.totalSumPhotoOrder +
          this.$store.state.storeCart.modPhotoGiftSummary.totalSumPhotoGift;

        // končni znesek z vsemi popusti
        this.$store.state.storeCart.totalSumCart =
          this.$store.state.storeCart.totalSumPromoCodeDiscountPrice;

        this.$store.state.storeCart.promoCodeAlreadyActivated = true;
        this.$store.state.storeCart.activePromoCodeActivated = true;

        console.log("==> PROMO CODE ACTIVATED");
        console.log(this.$store.state.storeCart.modPhotoGiftSummary);
        /*console.log(
          "modPhotoOrderSummary.totalSumLabPrice: " +
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumLabPrice
        );
        console.log(
          "modPhotoOrderSummary.totalSumPhotoOrder: " +
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumPhotoOrder
        );
        console.log(
          "modPhotoOrderSummary.totalSumPromoCodeDiscountPrice: " +
            this.$store.state.storeCart.modPhotoOrderSummary
              .totalSumPromoCodeDiscountPrice
        );
        console.log(
          "modPhotoOrderSummary.totalSumPromoCodeDiscount: " +
            this.$store.state.storeCart.modPhotoOrderSummary
              .totalSumPromoCodeDiscount
        );

        console.log(
          "modPhotoGiftSummary.totalSumLabPrice: " +
            this.$store.state.storeCart.modPhotoGiftSummary.totalSumLabPrice
        );
        console.log(
          "modPhotoGiftSummary.totalSumPhotoGift: " +
            this.$store.state.storeCart.modPhotoGiftSummary.totalSumPhotoGift
        );
        console.log(
          "modPhotoGiftSummary.totalSumPromoCodeDiscountPrice: " +
            this.$store.state.storeCart.modPhotoGiftSummary
              .totalSumPromoCodeDiscountPrice
        );
        console.log(
          "modPhotoGiftSummary.totalSumPromoCodeDiscount: " +
            this.$store.state.storeCart.modPhotoGiftSummary
              .totalSumPromoCodeDiscount
        );

        console.log(
          "AllDiscount: " +
            this.$store.state.storeCart.totalSumPromoCodeDiscount
        );
        console.log(
          "AllDiscountPrice: " +
            this.$store.state.storeCart.totalSumPromoCodeDiscountPrice
        );
        console.log(
          "totalSumCart: " + this.$store.state.storeCart.totalSumCart
        );*/
      } else {
        this.$store.state.storeCart.activePromoCodeActivated = false;
      }
    },
    async deleteItem(item) {
      try {
        await this.$store.dispatch("removeFromCart", {
          id: item.id,
          cartId: item.cartId, // cartId je ime zip datoteke, ki je unique
        });

        if (item.module == G_MODULE_PHOTO_GIFT)
          this.$store.dispatch("changeGiftInventory", {
            itemSimpleType: false,
            itemId: item.itemId,
            itemTypeId: item.itemTypeId,
            num: Number(item.itemCopies),
          });

        await this.$store.dispatch("getCartInfo");
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
  },
  beforeUpdate() {
    //console.log(">>> BEFORE UPDATE forceUpdate");
    this.$forceUpdate(); // update za dodano pred xx min
  },
  created() {
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
    this.G_MODULE_ALL = G_MODULE_ALL;

    setTimeout(() => (this.visibleMsg = false), 5000);
  },
  async mounted() {
    this.enableCashregister = false;
    await this.$store.dispatch("getCartInfo");
    this.enableCashregister = true;
  },
};
</script>
